module.exports = __webpack_public_path__ + "static/img/3-6.6.5.6b02fc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/5/3-6.6.5.png
// module id = vf8h
// module chunks = 0